import { createWebSocketStore } from 'src/components/#services/helpers';
export const getReferralInfoList = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'referral_getReferralInfoList',
        agent: 'referral',
        lang: 'en',
        auth: {
            type: 'webSite',
        },
    },
});
export const getReferralReward = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'reward_getUserReferralReward',
        agent: 'referral',
        lang: 'en',
        auth: {
            type: 'webSite',
        },
    },
});
export const getAllMyReferralRewards = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'registryTransaction_getAllMyReferralRewards',
        agent: 'transactions',
        lang: 'en',
        auth: {
            type: 'webSite',
        },
    },
});
export const getSubReferralsCount = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'referral_getSubReferralsCount',
        agent: 'referral',
        lang: 'en',
        auth: {
            type: 'webSite',
        },
    },
});
